<template>
    <div>
        <card-header title="Copy Custom Event" icon="fa-copy"/>

        <card-body v-if="event">
            <card-list>
                <subheader-list-item title="Copy to" icon="fa-copy"/>
                <container-list-item padded>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Registrations" label-position="inside">
                                <b-taginput
                                    v-model="selectedRegs"
                                    :data="filteredRegistrations"
                                    autocomplete
                                    open-on-focus
                                    field="_label"
                                    icon="search"
                                    placeholder="Add a registration..."
                                    @typing="regFilter = $event">
                                    <template slot="empty">No results.</template>
                                </b-taginput>
                            </b-field>
                            <p class="is-size-7 mt-1">
                                <a @click="selectAll">Add all ({{ registrations.length }})</a>
                                <a class="ml-3" @click="selectedRegs = []" v-if="selectedRegs.length">Clear</a>
                            </p>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
            <event-form :event="event" :card="card" :child="child" :registration-id="parseInt(props.registrationId)" custom/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" :disabled="!selectedRegIds.length" @click="submit"><i class="fas fa-copy mr-2"></i>Copy Event<span v-if="selectedRegIds.length > 1"> ({{ selectedRegIds.length }})</span></b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import {client as http} from '../../http_client';
    import CardHeader from '../../TIER/components/CardHeader';
    import CardBody from '../../TIER/components/CardBody';
    import CardFooter from '../../TIER/components/CardFooter';
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";
    import EventForm from '../trips/EventForm';

    import async from 'async';
    import {mapActions} from "vuex";

    export default {
        props: ['card', 'props', 'child'],
        components: {ContainerListItem, SubheaderListItem, EventForm, CardList, CardFooter, CardBody, CardHeader},
        data: function() {
            return {
                event: null,
                registration: {trip: {}, user: {}},
                registrations: [],
                selectedRegs: [],
                regFilter: ''
            };
        },
        computed: {
            selectedRegIds: function() {
                return this.selectedRegs.map(r => r.id);
            },
            filteredRegistrations: function() {
                let q = this.regFilter.toLowerCase();
                return this.registrations.filter(r =>
                    !this.selectedRegIds.includes(r.id) &&
                    (!q || r._label.toLowerCase().indexOf(q) >= 0));
            }
        },
        methods: {
            ...mapActions(['updateTasks']),
            loadEvent: function() {
                this.$emit('loading', true);

                async.series([
                    // Get event
                    (cb) => {
                        http.get('/api/registrations/' + this.props.registrationId + '/events/' + this.props.dayId + '/' + this.props.eventId, {force: true}).then(response => {
                            this.event = response.data;
                            // Copies start without documents — show the empty state
                            this.event.documents = [];
                            cb();
                        });
                    },
                    // Get registration
                    (cb) => {
                        http.get('/api/registrations/' + this.props.registrationId, {force: true}).then(response => {
                            this.registration = response.data;
                            cb();
                        });
                    },
                    // Get trip registrations
                    (cb) => {
                        http.get('/api/trips/' + this.registration.trip_id + '/registrations/0/1000', {force: true}).then(response => {
                            this.registrations = response.data.registrations;
                            this.registrations.sort((a, b) => {
                                return a.user.last_name.localeCompare(b.user.last_name);
                            });
                            this.registrations.forEach(r => {
                                r._label = r.user.last_name + ', ' + r.user.first_name + ((r.id === parseInt(this.props.registrationId)) ? ' (Duplicate)' : '');
                            });
                            cb();
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            selectAll: function() {
                this.selectedRegs = this.registrations.slice();
            },
            submit() {
                this.$emit('loading', true);

                let payload = {
                    ...this.event,
                    regIds: this.selectedRegIds
                };

                http.post('/api/registrations/' + this.props.registrationId + '/events/' + this.props.eventId + '/copy', payload, {force: true}).then(response => {
                    this.updateTasks();
                    this.$reloadCard('registrations');
                    this.$reloadCard('registration', {registrationId: this.props.registrationId});
                    this.$reloadCard('events', {dayId: this.props.dayId});
                    this.$reloadCard('tasks');
                    this.$reloadCard('task-details', {type: 'reg-events'});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadEvent();
        }
    };
</script>
